import React, { useContext, useState } from 'react'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'

import { Item } from '../types'
import { LinkContext } from '../context'

import style from './index.scss'

const Pane: React.FC<{
  title?: string
  items: Array<Item>
  onClose?: () => void
  onExit?: () => void
}> = ({ title, items, onClose, onExit }) => {
  const Link = useContext(LinkContext)

  const [selection, setSelection] = useState<number | null>(null)

  return (
    <>
      <div className={classNames(style.pane)}>
        {title && <div className={classNames(style.title)}>{title}</div>}
        {items.map((item, i) => {
          if (!item) {
            return null
          }

          if ('url' in item) {
            return (
              <Link
                key={i}
                to={item.url}
                className={classNames(item.className, style.link, style.item)}
              >
                {item.label}
              </Link>
            )
          }

          if ('items' in item) {
            return (
              <button
                key={i}
                className={classNames(item.className, style.item, style.link, {
                  [style.active]: i === selection,
                })}
                onClick={() => setSelection(i)}
              >
                {item.title}
                <Icon
                  size="small"
                  type="chevron-right"
                  className={classNames(style.chevron, style.icon)}
                />
              </button>
            )
          }

          const x = { render: item }

          return <x.render key={i} />
        })}
        {onClose && (
          <Icon
            size="medium"
            type="arrow-left"
            className={classNames(style.arrow, style.icon, style.link)}
            onClick={onClose}
          />
        )}
        {onExit && (
          <Icon
            size="small"
            type="cross"
            className={classNames(style.cross, style.icon, style.link)}
            onClick={onExit}
          />
        )}
      </div>
      {(() => {
        if (selection !== null) {
          const selectedItem = items[selection]
          if (selectedItem && 'items' in selectedItem) {
            return (
              <Pane
                key={selection}
                title={selectedItem.title}
                items={selectedItem.items}
                onClose={() => setSelection(null)}
                onExit={onExit}
              />
            )
          }
        }

        return null
      })()}
    </>
  )
}

export default Pane
